<template>
	<Board :gameState=gameState :mode=mode
		v-on:playingStart='playingStart'
		v-on:countUp='countUp'
		v-on:finish='finish'
	></Board>
	<Modal :gameState=gameState 
		v-on:memorizeStart='memorizeStart'
		v-on:retry='retry'
		v-on:level-change='levelChange'
		v-on:tweet='tweet'
	></Modal>
	<div class='timer' v-if='gameState !== "level-select"'>
		<img src='./assets/clock.svg' /> {{ timerStr }} 
		<span style='margin: 0px 50px'>  </span>
		<img src='./assets/mouse.svg' /> {{ moveCount }}
	</div>
	<div class='giveup' v-if='gameState === "playing"' v-on:click='gameState="giveup"'>
		<img src='./assets/giveup.svg' />
		ギブアップ
	</div>
	<div class='description' v-if='gameState === "level-select"'>
		Developed by <a href='https://twitter.com/yubais' target="_blank" rel="noopener noreferrer">@yubais</a>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Board from './components/Board.vue'
import Modal from './components/Modal.vue'

export default defineComponent({
	name: 'App',
	components: {
		Board,
		Modal,
	},
	data: () => ({
		gameState: 'level-select',
		mode: 'open',
		interval: 0,
		timer: 0,
		moveCount: 0,
	}),
	methods: {
		memorizeStart: function(mode: string) {
			this.mode = mode
			this.gameState = 'memorize'
		},
		playingStart: function() {
			this.gameState = 'playing'
		},
		countUp: function() {
			this.moveCount++
		},
		finish: function() {
			this.gameState = 'finish'
		},
		retry: function() {
			this.gameState = 'memorize'
		},
		levelChange: function() {
			this.gameState = 'level-select'
		},
		tweet: function() {
			let text = ''
			if (this.gameState === 'finish') {
				// クリアした場合の文言
				if (this.mode === 'hidden') text += "「すべて隠す」を "
				if (this.mode === 'even') text += "「半分を隠す」を "
				if (this.mode === 'open') text += "「隠さない」を "
				text += this.timer / 10 + " 秒、 " + this.moveCount + " 手でクリアしました！\n\n"
			}
			text += "目隠しスライドパズル"

			const encoded = encodeURIComponent(text)
			const url = "https://twitter.com/intent/tweet?text=" + encoded + "&url="+ document.location
			window.open(url)
		}
	},
	watch: {
		gameState: function(newValue, oldValue) {
			if (newValue === 'memorize') {
				this.timer = 0
				this.moveCount = 0
			}
			if (newValue === 'playing') {
				this.interval = setInterval( () => {
					this.timer++
				}, 100)
			}
			if (oldValue === 'playing') {
				clearInterval(this.interval)
			}
		}
	},
	computed: {
		timerStr: function() {
			if (this.timer % 10 === 0) {
				return this.timer / 10 + '.0'
			} else {
				return this.timer / 10
			}
		}
	}
})
</script>

<style>
html {
	overscroll-behavior: none;
}

body {
	background: #002244;
	margin: 0px;
	padding: 0px;
	width: 600px;
}

img {
	width: 48px;
	height: 48px;
	filter: invert();
	vertical-align: middle;
	padding-right: 20px;
}

.message,
.timer,
.giveup
{
	margin: 50px;
	margin-top: 20px;
	padding: 0px;
	width: 500px;
	text-align: center;
}

.description
{
	width: 600px;
	text-align: center;
	margin-top: 20px;
	margin-bottom: 20px;
	font-size: 16px;
}

.description a {
	font-size: 16px;
}

.giveup {
	border: solid 1px #ffffff;
	padding: 10px 0px;
	border-radius: 5px;
	cursor: pointer;
}

* {
	user-select: none;
	font-size: 24px;
	color: #ffffff;
	font-family: Arial, Helvetica, sans-serif;
}
</style>
